import styled from 'styled-components';
import { th } from 'style/theme';

export const StyledLearnMoreLink = styled.span`
  align-self: start;
  color: ${th('colors.fountainBlue')};
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  cursor: pointer;
`;
